// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-sticky-column-one {\n    background: #23d160 !important;\n    color: white !important;\n}\n.is-sticky-column-two {\n    background: #167df0 !important;\n    color: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
